module.exports = __webpack_public_path__ + "assets/img/right-title-open-9f665f20.png";